import { makeStyles } from "@material-ui/styles";
import { titanStyle } from "../../../../style/titan.theme.constant";

export default makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    "&:hover, &:focus": {
      backgroundColor: titanStyle.titan_color.color_cfd8dc,
      width: "100%",
      color: titanStyle.titan_color.color_black,
    },
  },
  linkActive: {
    backgroundColor: titanStyle.titan_color.color_cfd8dc,
    width: "100%",
    borderRight: "2px solid" + titanStyle.titan_color.color_peacock_blue,
    fontSize: "14px",
    fontWeight: 500,
  },
  linkNested: {
    paddingLeft: 0,
    marginTop: ".2em",
    marginBottom: ".2em",
    "&:hover, &:focus": {
      backgroundColor: titanStyle.titan_color.color_cfd8dc,
      // paddingTop:4,
      // paddingBottom:4,
      color: titanStyle.titan_color.color_black,
    },
  },
  linkIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary + "99",
    transition: theme.transitions.create("color"),
    width: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    color: titanStyle.titan_color.color_peacock_blue,
  },
  linkText: {
    padding: 0,
    color: titanStyle.titan_color.color_black,
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 14,
    fontWeight: "normal",
    "&:hover, &:focus": {
      color: titanStyle.titan_color.color_black,
    },
  },
  linkTextActive: {
    color: titanStyle.titan_color.color_peacock_blue,
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingLeft: theme.spacing(2) + 7,
  },
  sectionTitle: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    height: 1,
    backgroundColor: "#D8D8D880",
  },
}));
